import { type JSX } from 'react';

interface SocialLink {
  icon: JSX.Element;
  href: string;
}

interface SocialLinksProps {
  links?: {
    github?: string;
    twitter?: string;
    linkedin?: string;
    portfolio?: string;
  };
}

const SocialLinks: React.FC<SocialLinksProps> = ({ links = {} }) => {
  const socialLinks: SocialLink[] = [
    {
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z" />
        </svg>
      ),
      href: links.github || '#'
    },
    {
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M6.29 18.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0020 3.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.073 4.073 0 01.8 7.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 010 16.407a11.616 11.616 0 006.29 1.84" />
        </svg>
      ),
      href: links.twitter || '#'
    },
    {
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M20.5 2h-17A1.5 1.5 0 002 3.5v17A1.5 1.5 0 003.5 22h17a1.5 1.5 0 001.5-1.5v-17A1.5 1.5 0 0020.5 2zM8 19H5v-9h3zM6.5 8.25A1.75 1.75 0 118.3 6.5a1.78 1.78 0 01-1.8 1.75zM19 19h-3v-4.74c0-1.42-.6-1.93-1.38-1.93A1.74 1.74 0 0013 14.19a.66.66 0 000 .14V19h-3v-9h2.9v1.3a3.11 3.11 0 012.7-1.4c1.55 0 3.36.86 3.36 3.66z" />
        </svg>
      ),
      href: links.linkedin || '#'
    },
    {
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M12 2a10 10 0 00-3.16 19.5c.5.08.66-.23.66-.5v-1.9c-2.67.6-3.22-1.3-3.22-1.3-.44-1.1-1.07-1.4-1.07-1.4-.88-.6.07-.6.07-.6.97.07 1.47 1 1.47 1 .86 1.5 2.26 1.07 2.8.82.09-.65.35-1.09.63-1.34-2.13-.24-4.37-1.07-4.37-4.74 0-1.05.37-1.9 1-2.57-.1-.25-.43-1.23.09-2.56 0 0 .82-.26 2.67 1a9.3 9.3 0 014.87 0c1.85-1.25 2.67-1 2.67-1 .52 1.33.19 2.31.09 2.56.62.67 1 1.52 1 2.57 0 3.68-2.24 4.5-4.38 4.74.36.31.67.91.67 1.85v2.74c0 .27.16.58.67.5A10 10 0 0012 2z" />
        </svg>
      ),
      href: links.portfolio || '#'
    }
  ];

  return (
    <div className="grid grid-cols-2 gap-4 mt-8">
      {socialLinks.map((link, index) => (
        <a
          key={index}
          href={link.href}
          className="flex items-center justify-center p-3 rounded-xl border border-gray-200 hover:bg-gray-50 transition-colors"
          target="_blank"
          rel="noopener noreferrer"
        >
          {link.icon}
        </a>
      ))}
    </div>
  );
};

export default SocialLinks; 